import React, { useEffect, useState } from "react";

import { __t } from "../../utils/translate";
import Stock from "@/images/icons/stock.svg";

const StockTimer = ({ productId }) => {
    const [stock, setStock] = useState<number | null>(null);
    const [initializing, setInitializing] = useState(true);
    const [minStock, setMinStock] = useState<number | null>(null);
    const intervalLength = Math.floor(Math.random() * (5 - 2 + 1)) + 2;

    useEffect(() => {
        const initialMinStock = getInitialMinStock();
        const initialStock = getInitialStock();
        setMinStock(initialMinStock);
        setStock(initialStock);
        setInitializing(false);
        localStorage.setItem(`stock_${productId}`, `${initialStock}`);
        localStorage.setItem(`minStock_${productId}`, `${initialMinStock}`);
    }, []);

    useEffect(() => {
        if (initializing || stock === undefined) {
            return;
        }

        const myVar = setInterval(() => {
            decrementStock();
        }, intervalLength * 1000);

        return () => clearInterval(myVar);
    }, [stock, initializing]);

    function getInitialStock() {
        let localStock = localStorage.getItem(`stock_${productId}`);
        return localStock ? parseInt(localStock) : Math.floor(Math.random() * 11) + 15;
    }

    function getInitialMinStock() {
        let localMinStock = localStorage.getItem(`minStock_${productId}`);
        return localMinStock ? parseInt(localMinStock) : Math.floor(Math.random() * 6) + 10;
    }

    const decrementStock = () => {
        if (stock <= minStock) {
            return;
        }

        const newStock = stock - 1;
        localStorage.setItem(`stock_${productId}`, newStock.toString());
        setStock(newStock);
    };

    // while initializing local storage, return null.
    if (initializing) {
        return null;
    }

    return <div className="text-[#f5a50f] flex flex-row items-center gap-1 text-base-16 md:text-h3 lg:text-h3-r lg:pt-1">
        <img
            className=""
            src={Stock}
            alt="Stock"
        />
        {__t("Only")} {stock} {__t("left in stock")}
    </div>;
};

export default StockTimer;